<p
    [ngStyle]="{backgroundColor: getColor()}"
    [ngClass]="{onlineColor: serverStatus === 'online'}"
    >Server with ID {{ serverId }} is {{ getServerStatus() }}</p>